import React from 'react';

const PictureImg = ({ src, webp, alt = '', loading = 'lazy', className, width, height, ...rest }) => {
    if (!src && !webp) return null;

    if (!webp) {
        return <img src={src} alt={alt} loading={loading} className={className} width={width} height={height} {...rest} />;
    }

    return (
        <picture>
            <source srcSet={webp} type="image/webp" />
            <img src={src || webp} alt={alt} loading={loading} className={className} width={width} height={height} {...rest} />
        </picture>
    );
};

export default PictureImg;
